// extracted by mini-css-extract-plugin
export default {"title":"Badge_title__Mk1xF"};